import Home from './pages/Home.vue';
import BeerList from './pages/BeerList.vue';
import Profil from './pages/Profil.vue';
import Notfound from './pages/404.vue';

const routes = [
  { path: '/', component: Home, props: true, meta: { transitionName: "fade" } },
  { path: '/udsendelser', component: BeerList, props: true, meta: { transitionName: "fade" } },
  { path: '/profil', component: Profil, props: true, meta: { transitionName: "fade" } },
  { path: '*', component: Notfound },
];


export default routes;
